import React from 'react'
import { useNavigate } from 'react-router-dom'


import HeroVide3 from "../../../../Assets/hero3.mp4"


import "./Hero.scss"

const Hero = () => {
    let Navigate = useNavigate()
    return (
        <>
            <div className="hero_container">
                <div className="upper_layer">
                    <div className="web_title_box">
                        <div className="title">
                            Flux Technologies
                        </div>
                        <div className="btn_box">
                            <div className="discover">
                                Discover Air
                            </div>
                            <div className="reserve" onClick={() => Navigate("contact")}>
                                Contact now
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom_layer">
                    <div className="epa">
                        <div className="heading">Official EPA range up to ¹</div>
                        <div className="data">520 mi</div>
                    </div>
                    <div className="price">
                        <div className="heading">Starting from ²</div>
                        <div className="data">$65,500</div>
                    </div>
                    <div className="power">
                        <div className="heading">Max power ³</div>
                        <div className="data">1,200+ hp</div>
                    </div>
                </div>
                <video src={HeroVide3} loop autoPlay playsInline muted ></video>
            </div>
        </>
    )
}

export default Hero